import React from 'react';
import SectionHeader from '../ui/SectionHeader';
import TestimonialCard from '../features/TestimonialCard';
import FadeIn from '../ui/FadeIn';
import { useSiteInfo } from '../../context/SiteInfoContext';

const TestimonialsSection = () => {
  const { siteInfo } = useSiteInfo();
  const testimonials = siteInfo?.testimonials;

  if (!testimonials) {
    return null;
  }

  const { sectionTitle, sectionSubtitle, items } = testimonials;

  return (
    <section className="testimonials-section" id="testimonials">
      <div className="container">
        <FadeIn>
          <SectionHeader
            eyebrow="Customer Stories"
            title={sectionTitle}
            subtitle={sectionSubtitle}
            light
          />
        </FadeIn>
        <div className="testimonials-grid">
          {items.map((testimonial) => (
            <FadeIn key={testimonial.id}>
              <TestimonialCard {...testimonial} />
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
